import { Button, Typography } from "@mui/material";
import { Form, Formik } from "formik";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { getDatosDeContacto, postDatosDeContacto, } from "../../../../../../redux/actions/informacion";
import FormikTextField from "../../../../../commons/formik/FormikTextField";
import { StyledDatosDeContacto } from "../../../../../styled/Empresa";

const validationSchema = Yup.object().shape({
  celular: Yup.string()
    .required("Este campo es obligatorio")
    .matches(
      /^[0-9()+-\s]*$/,
      "Solo se permiten números y los caracteres ( ) + - y espacio"
    )
    .max(30, "El número de celular debe tener como máximo 30 caracteres"),
  telefono: Yup.string()
    .required("Este campo es obligatorio")
    .matches(
      /^[0-9()+-\s]*$/,
      "Solo se permiten números y los caracteres ( ) + - y espacio"
    )
    .max(20, "El número de teléfono debe tener como máximo 20 caracteres"),
  eMail: Yup.string()
    .required("Este campo es obligatorio")
    .email("Mail inválido")
    .max(250, "El e-mail debe tener como máximo 250 caracteres"),
});

const datosContactoinitialValues = {
  telefono: "Sin Información",
  celular: "Sin Información",
  eMail: "Sin Información",
};

const DatosDeContacto = ({ data }) => {
  const dispatch = useDispatch();

  const handleSumbit = (data) => {
    dispatch(postDatosDeContacto(data)).then(() => {
      dispatch(getDatosDeContacto());
      toast.success("Los datos han sido actualizados correctamente");
    });
  };

  return (
    <Formik
      initialValues={{
        telefono: data.telefono || datosContactoinitialValues.telefono,
        celular: data.celular || datosContactoinitialValues.celular,
        eMail: data.mail || datosContactoinitialValues.eMail,
      }}
      onSubmit={handleSumbit}
      validationSchema={validationSchema}
    >
      {({ errors, touched }) => (
        <Form>
          <StyledDatosDeContacto.DatosDeContactoContainer
            container
            spacing={2}
          >
            <StyledDatosDeContacto.FormikInput>
              <Typography>Teléfono</Typography>
              <FormikTextField
                id="telefono"
                name="telefono"
                type="text"
                FormHelperTextProps={{
                  style: {
                    display: "none",
                  },
                }}
              />
              <StyledDatosDeContacto.ErrorDiv>
                {touched.telefono && errors.telefono && (
                  <Typography variant="caption" sx={{ color: "red" }}>
                    {errors.telefono}
                  </Typography>
                )}
              </StyledDatosDeContacto.ErrorDiv>
            </StyledDatosDeContacto.FormikInput>
            <StyledDatosDeContacto.FormikInput>
              <Typography>Celular</Typography>
              <FormikTextField
                id="celular"
                name="celular"
                type="text"
                FormHelperTextProps={{
                  style: {
                    display: "none",
                  },
                }}
              />

              <StyledDatosDeContacto.ErrorDiv>
                {touched.celular && errors.celular && (
                  <Typography variant="caption" sx={{ color: "red" }}>
                    {errors.celular}
                  </Typography>
                )}
              </StyledDatosDeContacto.ErrorDiv>
            </StyledDatosDeContacto.FormikInput>
            <StyledDatosDeContacto.FormikInput>
              <Typography>Mail</Typography>
              <FormikTextField
                id="eMail"
                name="eMail"
                type="text"
                FormHelperTextProps={{
                  style: {
                    display: "none",
                  },
                }}
              />
              <StyledDatosDeContacto.ErrorDiv>
                {touched.eMail && errors.eMail && (
                  <Typography variant="caption" sx={{ color: "red" }}>
                    {errors.eMail}
                  </Typography>
                )}
              </StyledDatosDeContacto.ErrorDiv>
            </StyledDatosDeContacto.FormikInput>
          </StyledDatosDeContacto.DatosDeContactoContainer>
          <StyledDatosDeContacto.ButtonContainer>
            <Button type="submit">Guardar</Button>
          </StyledDatosDeContacto.ButtonContainer>
        </Form>
      )}
    </Formik>
  );
};

export default DatosDeContacto;
